module.exports = __webpack_public_path__ + "img/home_icon_yaoshi_default.46822de8.png";